import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ScaleWithoutBorders from "./sections/ScaleWithoutBorders";
import PartneredWithLeaders from "./sections/PartneredWithLeaders";
import OperationalIntelligence from "./sections/OperationalIntelligence";
import TheFirmsImpact from "./sections/TheFirmsImpact";
import LatestInsights from "./sections/LatestInsights";
import SuccessStories from "./sections/SuccessStories";
import InitiateYourForge from "./sections/InitiateYourForge";
import FooterEssentials from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ScaleWithoutBorders />
      <PartneredWithLeaders />
      <OperationalIntelligence />
      <TheFirmsImpact />
      <LatestInsights />
      <SuccessStories />
      <InitiateYourForge />
      <FooterEssentials />
    </div>;
}